import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsFindBy, wsGetAll } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalUpdate(props) {
  const { selectedTransfers = [], reload, showNotify } = props;

  const guia = selectedTransfers[0]?.guia_transfer_view || {};

  const [dataChanging, setDataChanging] = useState({
    base_business_partner_id: guia.base_business_partner_id || '',
    base_zone_id: guia.base_zone_id || '',
    prog_distribution_staff_id_manager: guia.prog_distribution_staff_id_manager || '',
    prog_vehicle_id: guia.prog_vehicle_id || '',
    logi_reason_id: guia.logi_reason_id || '',
    prog_public_vehicle_id: guia.prog_public_vehicle_id || '',
    prog_public_distribution_id: guia.prog_public_distribution_id || '',
    type_transport: guia.type_transport || 'prv',
  });
  const [carriers, setCarriers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [reason, setReasons] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function getCarrier(TyTransport) {
    let response = '';
    if(TyTransport === 'prv'){
      response = await wsFindBy('logi/transportista', {CardCode: 'P20494328799'});
    }else{
      response = await wsFindBy('logi/transportista', {exclude: 'P20494328799'});
    }

    if (response.success) {
      setCarriers(response.data);

      if (TyTransport === 'prv' && response.data.length > 0) {
        console.log("ENTRO TY");
        handleChange('base_business_partner_id', response.data[0].base_business_partner_id);
      }
    }
  }

  async function getProgVehicle(TyTransport, bbpId) {
    let response = '';
    if (TyTransport === 'prv') {
      response = await wsFindBy('prog/vehicle', {
        base_business_partner_id: bbpId,
        base_zone_id: guia.base_zone_id,
      });
    } else {
      response = await wsFindBy('prog/public-vehicle', {
        base_business_partner_id: bbpId,
      });
    }
    if (response.success) setVehicles(response.data);
  }

  async function getDriver(TyTransport) {
    let response = '';
    if (TyTransport === 'prv') {
      response = await wsFindBy('prog/distribution-staff', {
        id: dataChanging.prog_distribution_staff_id_manager,
        base_zone_id: selectedTransfers[0]?.to_zone_id
      });
      if (response.success) {
        const dataWithType = response.data.map(item => ({
          ...item, type_driver: 'internal'
        }));
        setDrivers(dataWithType);
      }
    } else {
      response = await wsFindBy('prog/public-driver');
      if (response.success) {
        const dataWithType = response.data.map(item => ({
          ...item, type_driver: item.base_zone_id ? 'internal' : 'public'
        }));
        setDrivers(dataWithType);
      }
    }
  }

  async function getReasons() {
    let response = await wsGetAll('logi/reason-transfer');
    if (response.success) setReasons(response.data);
  }

  useEffect(() => {
    console.log("Datachahing:", dataChanging);
  }, [dataChanging]);
  
  useEffect(() => {
    getReasons();
    if (guia?.type_transport) {
      getCarrier(guia.type_transport);
    }
  }, []);

  // useEffect(() => {
  // if (carriers.length > 0 && !dataChanging.base_business_partner_id) {
  //     handleChange("base_business_partner_id", guia.base_business_partner_id);
  //     handleChange("prog_vehicle_id", guia.prog_vehicle_id);
  //     handleChange("prog_distribution_staff_id_manager", guia.prog_distribution_staff_id_manager);
  // }
  // }, [carriers]);

  useEffect(() => {
    if( dataChanging.type_transport) {
      setCarriers([]);
      setVehicles([]);
      setDrivers([]);
      setDataChanging(prev => ({
        type_transport: prev.type_transport,
        logi_reason_id: prev.logi_reason_id ?? null,
      }));
      getCarrier(dataChanging.type_transport);
    }
  }, [dataChanging.type_transport]);


  useEffect(() => {
    if ( dataChanging.base_business_partner_id !== null && dataChanging.base_business_partner_id !== undefined && dataChanging.type_transport ) {
      setVehicles([]);
      setDataChanging(prev => ({
        type_transport: prev.type_transport,
        base_business_partner_id: prev.base_business_partner_id,
        logi_reason_id: prev.logi_reason_id ?? null,
      }));
      getProgVehicle(dataChanging.type_transport, dataChanging.base_business_partner_id);
    }
  }, [dataChanging.base_business_partner_id]);

  useEffect(() => {
    if ( dataChanging.base_business_partner_id !== null && dataChanging.base_business_partner_id !== undefined && dataChanging.type_transport ) {
      setDrivers([]);
      setDataChanging(prev => ({
        type_transport: prev.type_transport,
        base_business_partner_id: prev.base_business_partner_id,
        logi_reason_id: prev.logi_reason_id ?? null,
      }));




      
      getDriver(dataChanging.type_transport);
    }
  }, [dataChanging.base_business_partner_id]);

  console.log("GUIA: ", guia);
  return (
    <>
      <Modal
        title={`Actualizar un preeliminar de guia de transferencia`}
        model={{ open: props.open, id: guia.id_guia }}
        setOpen={props.onClose}
        showNotify={props.showNotify}
        reload={reload}
        entity='logi/guia-transfer'
        dataForce={{
          base_business_partner_id: dataChanging.base_business_partner_id,
          prog_vehicle_id: dataChanging.prog_vehicle_id || null,
          prog_distribution_staff_id_manager: dataChanging.prog_distribution_staff_id_manager || null,
          prog_public_vehicle_id: dataChanging.prog_public_vehicle_id || null,
          prog_public_distribution_id: dataChanging.prog_public_distribution_id || null,
          logi_reason_id: dataChanging.logi_reason_id,
          type_transport: dataChanging.type_transport,
        }}
      >
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo transporte</InputLabel>
          <Select
            required
            value={dataChanging.type_transport || guia.type_transport || ''}
            onChange={(e) => handleChange('type_transport', e.target.value)}
          >
            <MenuItem value="prv">Privado.- Unidades de la empresa</MenuItem>
            <MenuItem value="pbl">Público.- Transportistas terceros</MenuItem>
          </Select>
        </FormControl>

        <Autocomplete
          disableClearable
          options={carriers}
          getOptionLabel={(item) => `${item.CardName} (Código: ${item.CardCode})`}
          value={
            carriers.find(
              (item) =>
                String(item.base_business_partner_id) ===
                String(dataChanging.base_business_partner_id || guia.base_business_partner_id)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Transportista" margin="normal" fullWidth />
          )}
          onChange={(e, item) =>
            handleChange('base_business_partner_id', item?.base_business_partner_id || null)
          }
        />

        <Autocomplete
          disableClearable
          options={vehicles}
          getOptionLabel={(item) => `${item.name || ''} (Placa: ${item.code})`}
          renderInput={(params) => (
            <TextField {...params} label="Vehículo" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            if (dataChanging.type_transport === 'pbl') {
              handleChange('prog_public_vehicle_id', item?.id || null);
            } else {
              handleChange('prog_vehicle_id', item?.id || null);
            }
          }}
          value={
            dataChanging.type_transport === 'pbl'
              ? vehicles.find(v => String(v.id) === String(dataChanging.prog_public_vehicle_id || guia.prog_public_vehicle_id)) || null
              : vehicles.find(v => String(v.id) === String(dataChanging.prog_vehicle_id || guia.prog_vehicle_id)) || null
          }
        />

        <Autocomplete
          disableClearable
          options={drivers}
          getOptionLabel={(item) =>
            `${item.name} (${item.type_driver === 'public' ? 'Público' : 'Interno'})`
          }
          value={
            drivers.find(
              (d) =>
                String(d.id) === String(dataChanging.prog_public_distribution_id || guia.prog_public_distribution_id) ||
                String(d.id) === String(dataChanging.prog_distribution_staff_id_manager || guia.prog_distribution_staff_id_manager)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Chofer" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {
            if (!item) return;

            if (item.type_driver === 'public') {
              handleChange('prog_public_distribution_id', item.id);
              handleChange('prog_distribution_staff_id_manager', null);
            } else {
              handleChange('prog_distribution_staff_id_manager', item.id);
              handleChange('prog_public_distribution_id', null);
            }
          }}
        />

        <Autocomplete
          disableClearable
          options={reason}
          getOptionLabel={(item) => `${item.reason}`}
          value={
            reason.find(
              (r) => String(r.id) === String(dataChanging.logi_reason_id || guia.logi_reason_id)
            ) || null
          }
          renderInput={(params) => (
            <TextField {...params} label="Motivo" margin="normal" fullWidth />
          )}
          onChange={(e, item) => handleChange('logi_reason_id', item?.id || null)}
        />
      </Modal>
    </>
  );
});
